var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    {
      staticClass: "overflow-x-hidden",
      attrs: { width: "100dvw", height: "100dvh" },
    },
    [
      _vm.isLoggedIn && _vm.$route.name != "Login" && _vm.terminalMode != "true"
        ? _c(
            "v-navigation-drawer",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closeNavigation,
                  expression: "closeNavigation",
                },
              ],
              ref: "navigationDrawer",
              staticClass: "rounded-0 d-none d-sm-none d-md-flex",
              attrs: {
                app: "",
                flat: "",
                "mini-variant": _vm.mini,
                "mobile-breakpoint": "xs",
                "mini-variant-width": "80px",
              },
              on: {
                "update:miniVariant": function ($event) {
                  _vm.mini = $event
                },
                "update:mini-variant": function ($event) {
                  _vm.mini = $event
                },
              },
            },
            [
              _vm.$route.name != "Setup" && _vm.terminalMode != "true"
                ? _c("Navigation", {
                    attrs: { mini: _vm.mini },
                    on: {
                      closeNavigation: function ($event) {
                        _vm.mini = !_vm.mini
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-main",
        { style: _vm.mainStyle },
        [
          !_vm.isMobileDevice
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "px-7 pb-8",
                      attrs: { justify: "space-between", "no-gutters": "" },
                    },
                    [
                      _vm.$route.name == "Login"
                        ? _c("v-col", { attrs: { cols: "3" } })
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _vm.isMobileDevice
                            ? _c("v-img", {
                                attrs: {
                                  src: _vm.source,
                                  "max-height": "85px",
                                  "max-width": "85px",
                                  contain: "",
                                },
                                on: { click: _vm.emitLogoClicked },
                              })
                            : _vm._e(),
                          !_vm.isMobileDevice
                            ? _c("v-img", {
                                attrs: {
                                  src: _vm.source,
                                  "max-height": "170px",
                                  "max-width": "170px",
                                  contain: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "d-flex align-center",
                              attrs: { "no-gutters": "", justify: "end" },
                            },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", color: _vm.setColor() },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-avatar",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-4",
                                                  attrs: {
                                                    color: _vm.setColor(),
                                                    size: "10",
                                                  },
                                                },
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3259186791
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.setConnectionText())),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-switch",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.setLocalStorageTheme()
                                    },
                                  },
                                  model: {
                                    value: _vm.$vuetify.theme.dark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.$vuetify.theme, "dark", $$v)
                                    },
                                    expression: "$vuetify.theme.dark",
                                  },
                                },
                                [
                                  _vm.$vuetify.theme.dark
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("mdi-white-balance-sunny")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("mdi-moon-waning-crescent")]
                                      ),
                                ],
                                1
                              ),
                              _c("LanguagePicker"),
                              (_vm.isMobileDevice &&
                                _vm.$route.name != "Login") ||
                              (_vm.terminalMode == "true" &&
                                _vm.$route.name != "Login")
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.logout()
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-logout")])],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("router-view", { class: _vm.isMobileDevice ? "" : "" }),
                ],
                1
              )
            : _vm.terminalMode == "true"
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "px-7 pb-2",
                      attrs: { justify: "space-between", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _vm.isMobileDevice
                            ? _c("v-img", {
                                attrs: {
                                  src: _vm.source,
                                  "max-height": "30vh",
                                  "max-width": "30vh",
                                  contain: "",
                                },
                                on: { click: _vm.emitLogoClicked },
                              })
                            : _vm._e(),
                          !_vm.isMobileDevice
                            ? _c("v-img", {
                                attrs: {
                                  src: _vm.source,
                                  "max-height": "170px",
                                  "max-width": "170px",
                                  contain: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "d-flex align-center",
                              attrs: { "no-gutters": "", justify: "end" },
                            },
                            [
                              _c("v-avatar", {
                                staticClass: "mr-2",
                                attrs: { color: _vm.setColor(), size: "10" },
                              }),
                              _c(
                                "v-switch",
                                {
                                  staticClass: "mr-8",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setLocalStorageTheme()
                                    },
                                  },
                                  model: {
                                    value: _vm.$vuetify.theme.dark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.$vuetify.theme, "dark", $$v)
                                    },
                                    expression: "$vuetify.theme.dark",
                                  },
                                },
                                [
                                  _vm.$vuetify.theme.dark
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("mdi-white-balance-sunny")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("mdi-moon-waning-crescent")]
                                      ),
                                ],
                                1
                              ),
                              _c("LanguagePicker"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-8",
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.logout()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-logout")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("router-view", { class: _vm.isMobileDevice ? "" : "" }),
                ],
                1
              )
            : _vm._e(),
          _vm.isMobileDevice && _vm.terminalMode == "false"
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "space-between", "no-gutters": "" } },
                    [
                      _vm.isMobileDevice
                        ? _c("v-img", {
                            attrs: {
                              src: _vm.source,
                              "max-height": "85px",
                              "max-width": "85px",
                              contain: "",
                            },
                            on: { click: _vm.emitLogoClicked },
                          })
                        : _vm._e(),
                      _c(
                        "v-row",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { "no-gutters": "", justify: "end" },
                        },
                        [
                          _c("v-avatar", {
                            staticClass: "mr-4",
                            attrs: { color: _vm.setColor(), size: "10" },
                          }),
                          _c(
                            "v-switch",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.setLocalStorageTheme()
                                },
                              },
                              model: {
                                value: _vm.$vuetify.theme.dark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.$vuetify.theme, "dark", $$v)
                                },
                                expression: "$vuetify.theme.dark",
                              },
                            },
                            [
                              _vm.$vuetify.theme.dark
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [_vm._v("mdi-white-balance-sunny")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [_vm._v("mdi-moon-waning-crescent")]
                                  ),
                            ],
                            1
                          ),
                          _c("LanguagePicker"),
                          _vm.isMobileDevice || _vm.terminalMode == "true"
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.logout()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "d-flex d-md-none mr-2" },
                                    [_vm._v("mdi-logout")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("router-view", { class: _vm.isMobileDevice ? "" : "" }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("Notification", { on: { HideDrawer: _vm.hideDrawer } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }